// extracted by mini-css-extract-plugin
export default {"subjectsEdit":"subjects-edit_subjectsEdit__56o38","subjectsEditContent":"subjects-edit_subjectsEditContent__tKonw"};